// extracted by mini-css-extract-plugin
module.exports = {"containerContent":"styles_containerContent__hejm8","containerPricelistModal":"styles_containerPricelistModal__2yqjZ","isWidePadding":"styles_isWidePadding__mHoCM"};